import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import ShortcutIcon from '@mui/icons-material/Shortcut';
import { MenuItem } from 'types/global';

type ShorcutsProps = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function Shorcuts({ selected, onSelect, open }: ShorcutsProps) {
	const { t } = useTranslation();

	return (
		<ListItem
			button
			component={Link}
			to="/shorcuts"
			selected={selected === MenuItem.Shorcuts}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.Shorcuts)}
		>
			<ListItemIcon>
				<ShortcutIcon />
			</ListItemIcon>
			{open && <ListItemText primary={t('common:shorcuts')} />}
		</ListItem>
	);
}
